export default __webpack_public_path__ + "static/media/gritter-icon.ff692061.svg";